import { ColorRepresentation } from 'three';

import { getRoofFaceColor, LayoutPolygonStyle } from './style';

// Since each roof face has its own polygon there will be very many overlapping lines in a fully cut roof. This file
//   specifies the desired "render order," enforced by `RoofFaceSegmentsRenderer`, to avoid z-fighting and ensure that
//   emphasised faces are always correctly rendered.
//
// Currently implemented not as a true render order, but by processing all the bounds lines before rendering to ensure
//   there are no overlapping segments. If there is ever a dedicated 2D visual for roof faces, we should use actual
//   z-index bumping for better results there.

const styledLayoutPolygonRenderOrder: Record<LayoutPolygonStyle, number> = {
  'featurePattern.normal': -11,
  'featurePattern.faded': -10,
  'featurePattern.fadedButBarelyEmphasised': -9,
  'featurePattern.barelyEmphasised': -8,
  'featurePattern.emphasised': -7,
  'featurePattern.highlighted': -6,

  'featureArea.normal': -5,
  'featureArea.faded': -4,
  'featureArea.fadedButBarelyEmphasised': -3,
  'featureArea.barelyEmphasised': -2,
  'featureArea.emphasised': -1,
  'featureArea.highlighted': 0,

  // feature pattern containers and feature areas are never actually handled be the same renderer as roof plane objects,
  //  so consider this a comment a dividing line between two render order groups for now :)

  'ceiling.normal': 1,
  'ceiling.faded': 2,
  'ceiling.fadedButBarelyEmphasised': 3,
  'ceiling.barelyEmphasised': 4,
  'ceiling.emphasised': 5,
  'ceiling.highlighted': 6,

  'roof.normal': 7,
  'roof.faded': 8,
  'roof.fadedButBarelyEmphasised': 9,
  'roof.barelyEmphasised': 10,
  'roof.emphasised': 11,
  'roof.highlighted': 12,
};

let colorPriorityCache: Map<ColorRepresentation, number> | null = null;

export function getPolygonFaceRenderOrder(color: ColorRepresentation) {
  // FIXME: merge equivalent color representations?

  if (colorPriorityCache === null) {
    colorPriorityCache = new Map();

    for (const [style, priority] of Object.entries(styledLayoutPolygonRenderOrder)) {
      const color = getRoofFaceColor(style as LayoutPolygonStyle);

      if (!colorPriorityCache.has(color) || colorPriorityCache.get(color)! < priority) {
        colorPriorityCache.set(color, priority);
      }
    }
  }

  return colorPriorityCache.get(color) ?? 0;
}
